module.exports = ".item-react {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    padding: 0 5px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/chat/communication-reaction/communication-reaction.component.css
// module id = ./src/app/commons/chat/communication-reaction/communication-reaction.component.css
// module chunks = main